import { createStore } from "vuex";
import getSite from "@/utils/getSite";

export default createStore({
  state: {
    // Set the beginning state of all store data.
    cookieConsent: false,
    site: getSite(),
    pageValidating: "",
    currentPage: "",
    wantsCancellation: false,
    wantsMedical: false,
    numberOfTravellers: "1",
    oldestTraveller: "",
    departureDate: "",
    returnDate: "",
    tripCost: "",
    province: "",
    confirmEligibility: null,
    medicalQuestion2: null,
    medicalQuestion3: null,
    medicalQuestion4: null,
    medicalQuestion5: null,
    medicalQuestion6: null,
    medicalQuestion7: null,
    medicalQuestion8: null,
    medicalQuestion9: null,
    medicalQuestion10: null,
    medicalQuestion11: null,
    medicalQuestion12: null,
    medicalQuestion13: null,
    medicalQuestion14: null,
    medicalQuestion15: null,
    medicalQuestion16: null,
    medicalQuestion17: null,
    medicalQuestion18: null,
    medicalQuestion19: null,
    medicalQuestion20: null,
    medicalQuestion21: null,
    medicalQuestion22: null,
    medicalQuestion23: null,
    medicalQuestion24: null,
    medicalQuestion25: null,
    medicalQuestion26: null,
    confirmMedical: false,
    confirmNotice: null,
    tripStart: "",
    oldestTraveller_dob: "",
    oldestTraveller_isPrimary: true,
    traveller1_firstname: "",
    traveller1_lastname: "",
    traveller1_dob: "",
    traveller2_firstname: "",
    traveller2_lastname: "",
    traveller2_dob: "",
    traveller3_firstname: "",
    traveller3_lastname: "",
    traveller3_dob: "",
    traveller4_firstname: "",
    traveller4_lastname: "",
    traveller4_dob: "",
    traveller5_firstname: "",
    traveller5_lastname: "",
    traveller5_dob: "",
    traveller6_firstname: "",
    traveller6_lastname: "",
    traveller6_dob: "",
    traveller7_firstname: "",
    traveller7_lastname: "",
    traveller7_dob: "",
    traveller8_firstname: "",
    traveller8_lastname: "",
    traveller8_dob: "",
    traveller9_firstname: "",
    traveller9_lastname: "",
    traveller9_dob: "",
    traveller10_firstname: "",
    traveller10_lastname: "",
    traveller10_dob: "",
    address1: "",
    address2: "",
    city: "",
    postalcode: "",
    phone: "",
    email: "",
    creditcard: "",
    creditcard_name: "",
    expiration: "",
    creditcard_cvv: "",
    renewAutomatically: false,
    confirmWhatsNotCovered: false,
    confirmPrivacyPolicy: false,
    confirmTerms: false,
    confirmTermsPrivacyPolicy: false,
    confirmCASL: false,
    confirmCoverage: "",    
    fulfillment: "email",
    product: "",
    products: "",
    offerRequest: null,
    policyNumber:"",
    transactionid: "",
    answers: null,
    score: null,
    survey: null
  },
  mutations: {
    beginValidation(state) {
      // Flag step as currently being validated.
      if(state.pageValidating===""){
      state.pageValidating = state.currentPage;
      }
    },
    setOldestTravellerDob(state, value: string) {
      state.oldestTraveller_dob = value || "";
    },
    setDepartureDate(state, value: string) {
      state.departureDate = value || "";
    },
    setReturnDate(state, value: string) {
      state.returnDate = value || "";
    },
    setProvince(state, value: string) {
      state.province = value || "";
    },
    setTripCost(state, value: string) {
      state.tripCost = value || "";
    },
    setNumberOfTravellers(state, value: string) {
      state.numberOfTravellers = value || "1";
    },
    updateOldestTraveller(state, oldestTraveller) {
      state.oldestTraveller = oldestTraveller;
    },
    updateProducts(state, payload){
      state.products=payload;
    },
    updatePolicyNumber(state, payload){
      state.policyNumber=payload.PolicyNumber;
      state.transactionid = payload.Payments[0].TransactionIdentifier;
    },
    setProduct(state, product){
      state.product=product;
      if(product.Product.ProductCode!=="CIBCAnnual8Day"&&
        product.Product.ProductCode!=="CIBCIAnnual8Day"&&
        product.Product.ProductCode!=="CIBCAnnual18Day"&&
        product.Product.ProductCode!=="CIBCIAnnual18Day") {
        state.renewAutomatically=false;
      }
    },
    setAnswers(state, answers){
      state.answers=answers;
    },
    setScore(state, score){
      state.score=score;
    },
    setSurvey(state, survey){
      state.survey=survey;
    },
    setOfferRequest(state, offerRequest){
      state.offerRequest=offerRequest;
    },    
    // Update the store when user moves to next or previous step/page
    changeStep(state, payload) {
      // Update the state with the payload
      if (payload.page === "TypeOfCoverage") {
        state.wantsCancellation = payload.wantsCancellation;
        state.wantsMedical = payload.wantsMedical;
        if(!isNaN(parseInt(state.oldestTraveller,10))){
          if(state.wantsMedical===true&&parseInt(state.oldestTraveller,10)>59){
            state.numberOfTravellers="1";
          }
        }
      } 
      else if (payload.page === "TravelPlans") {
        
          state.product="";
          state.oldestTraveller_dob=payload.oldestTraveller_dob;
          if(payload.numberOfTravellers==="1"){
            state.traveller1_dob=payload.oldestTraveller_dob;
            state.oldestTraveller_isPrimary=true;
          }
          else if (state.traveller1_dob!==""&&state.oldestTraveller_isPrimary===true){
            state.traveller1_dob=payload.oldestTraveller_dob;
          }
          state.numberOfTravellers = payload.numberOfTravellers;
          state.oldestTraveller = payload.oldestTraveller;
          state.departureDate = payload.departureDate;
          state.tripStart = payload.tripStart;
          state.returnDate = payload.returnDate;
          state.tripCost = payload.tripCost;
          state.province = payload.province; 
        }
       else if (payload.page ==="TravellerAges") {
        state.oldestTraveller_dob=payload.oldestTraveller_dob;
        state.traveller1_dob=payload.traveller1_dob;
        state.traveller2_dob=payload.traveller2_dob;
        state.traveller3_dob=payload.traveller3_dob;
        state.traveller4_dob=payload.traveller4_dob;
        state.traveller5_dob=payload.traveller5_dob;
        state.traveller6_dob=payload.traveller6_dob;
        state.traveller7_dob=payload.traveller7_dob;
        state.traveller8_dob=payload.traveller8_dob;
        state.traveller9_dob=payload.traveller9_dob;
        state.traveller10_dob=payload.traveller10_dob; 
      }
      else if (payload.page === "Questionnaire1") {
        state.confirmEligibility= payload.confirmEligibility;
      } 
      else if (payload.page === "Questionnaire2") {
        state.medicalQuestion2= payload.medicalQuestion2;
        state.medicalQuestion3= payload.medicalQuestion3;
        state.medicalQuestion4= payload.medicalQuestion4;
        state.medicalQuestion5= payload.medicalQuestion5;
        state.medicalQuestion6= payload.medicalQuestion6;
        state.medicalQuestion7= payload.medicalQuestion7;
        state.medicalQuestion8= payload.medicalQuestion8;
        state.medicalQuestion9= payload.medicalQuestion9;
        state.medicalQuestion10= payload.medicalQuestion10;
        state.medicalQuestion11= payload.medicalQuestion11;
      } 
      else if (payload.page === "Questionnaire3") {
        state.medicalQuestion12= payload.medicalQuestion12;
        state.medicalQuestion13= payload.medicalQuestion13;
        state.medicalQuestion14= payload.medicalQuestion14;
        state.medicalQuestion15= payload.medicalQuestion15;
        state.medicalQuestion16= payload.medicalQuestion16;
        state.medicalQuestion17= payload.medicalQuestion17;
        state.medicalQuestion18= payload.medicalQuestion18;
        state.medicalQuestion19= payload.medicalQuestion19;
        state.medicalQuestion20= payload.medicalQuestion20;
        state.medicalQuestion21= payload.medicalQuestion21;
        state.medicalQuestion22= payload.medicalQuestion22;
        state.medicalQuestion23= payload.medicalQuestion23;
        state.medicalQuestion24= payload.medicalQuestion24;
        state.medicalQuestion25= payload.medicalQuestion25;
        state.medicalQuestion26= payload.medicalQuestion26;
        state.confirmMedical=payload.confirmMedical;
      } 
      else if (payload.page === "Notices") {
        state.confirmNotice= payload.confirmNotice;
      } 
      else if (payload.page ==="ApplicantInfo") {       
        state.tripStart=payload.tripStart;
        state.traveller1_firstname=payload.traveller1_firstname;
        state.traveller1_lastname=payload.traveller1_lastname;
        state.address1=payload.address1;
        state.address2=payload.address2;
        state.city=payload.city;
        state.postalcode=payload.postalcode;
        state.phone=payload.phone;
        state.email=payload.email;
        state.province=payload.province;
        state.confirmCASL=payload.confirmCASL;
        state.fulfillment=payload.fulfillment;
        state.confirmCoverage=payload.confirmCoverage;
      } 
      else if (payload.page ==="TravellerInfo") {
        state.traveller2_firstname=payload.traveller2_firstname;
        state.traveller2_lastname=payload.traveller2_lastname;
        state.traveller3_firstname=payload.traveller3_firstname;
        state.traveller3_lastname=payload.traveller3_lastname;
        state.traveller4_firstname=payload.traveller4_firstname;
        state.traveller4_lastname=payload.traveller4_lastname;
        state.traveller5_firstname=payload.traveller5_firstname;
        state.traveller5_lastname=payload.traveller5_lastname;
        state.traveller6_firstname=payload.traveller6_firstname;
        state.traveller6_lastname=payload.traveller6_lastname;
        state.traveller7_firstname=payload.traveller7_firstname;
        state.traveller7_lastname=payload.traveller7_lastname;
        state.traveller8_firstname=payload.traveller8_firstname;
        state.traveller8_lastname=payload.traveller8_lastname;
        state.traveller9_firstname=payload.traveller9_firstname;
        state.traveller9_lastname=payload.traveller9_lastname;
        state.traveller10_firstname=payload.traveller10_firstname;
        state.traveller10_lastname=payload.traveller10_lastname;
      } 
      else if (payload.page ==="PaymentInfo") {
        state.creditcard=payload.creditcard;
        state.creditcard_name=payload.creditcard_name;
        state.expiration=payload.expiration;
        state.creditcard_cvv=payload.creditcard_cvv;
        state.confirmTerms=payload.confirmTerms;
        state.confirmTermsPrivacyPolicy=payload.confirmTermsPrivacyPolicy;
        state.renewAutomatically=payload.renewAutomatically;
      }
      // Clear validating flag if validation was completed.
      if(payload.didValidation===true&&state.pageValidating===state.currentPage) {state.pageValidating="";}

      state.currentPage=payload.currentPage;
    }
  }
});
